<template>
  <div class="content content--sub">
    <OverlayLoader v-if="!$store.getters.teamMembersLoaded"></OverlayLoader>
    <MyHeader :breadcrumbItems="[

        {
          name: pageName.name,
          path: `/${$route.params.companySlug}/meet-your-team`
        }
      ]"/>

    <header class="content-header">
      <h1>{{ pageName.name }}</h1>
      <button :class="['article-list-button', {active: showList}]" @click="showList = ! showList"><i class="icon-list"></i></button>
    </header>

    <!-- tabs for mobile -->
    <transition name="fade">
      <div class="article-list" v-if="showList">
        <TabMenuList :tabs="tabContent" @closeMenu="showList=false"></TabMenuList>
      </div>
    </transition>

    <div class="container main-content--tabbed" v-if="useTeamMembersTeams">
      <div class="row">
        <div class="col-lg-3 d-none d-lg-block">
          <TabMenuList :tabs="tabContent"></TabMenuList>
        </div>
        <div class="col-lg-9 article-content">
          <div class="section-header">
            <form class="form--oneliner">
              <div class="input-wrapper">
                <input type="text" v-model="search" placeholder="Search...">
              </div>
              <button @click.prevent><i class="icon-search"></i></button>
            </form>
          </div>
          <div class="row boxes-row" v-if="currentSelectedTab">
            <div class="col-lg-4" v-for="member in currentSelectedTab.members" :key="member.idTeamMember">
              <TeamMemberBox :box="member" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container article-content" v-else>
      <div class="section-header">
        <form class="form--oneliner">
          <div class="input-wrapper">
            <input type="text" v-model="search" placeholder="Search...">
          </div>
          <button @click.prevent><i class="icon-search"></i></button>
        </form>
      </div>
      <div class="row boxes-row ">
        <div class="col-lg-4" v-for="member in filteredTeamMembers" :key="member.idTeamMember">
          <TeamMemberBox :box="member" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from '../components/general/Header'
import {slugify} from "@/helpers/slugify";
import settings from "@/settings";
import TeamMemberBox from "@/components/persons/TeamMemberBox";
import tabsMixin from "@/mixins/tabsMixin";
import TabMenuList from "@/components/tabs/TabMenuList";
import OverlayLoader from "@/components/general/OverlayLoader";
import settingUser from "@/api/settingUser";
import moment from "moment/moment";
export default {
  name: "MeetYourTeam",
  components: {OverlayLoader, TabMenuList, TeamMemberBox, MyHeader},
  data () {
    return {
      showList: false,
      search: ''
    }
  },
  mixins: [tabsMixin],
  computed: {
    useTeamMembersTeams() {
      return this.$store.getters.settingsCompanyFlagByCode(settings.SETTING_TYPES_FLAGS.GROUP_TEAM_MEMBERS)
    },
    engagements() {
      return this.$store.getters.engagements
    },
    tabContent() {
      let teams = [];
      this.engagements.filter(item => {
        return !item.idEngagementParent
      }).forEach(item => {
        teams.push({
          id: item.idEngagement,
          name: item.name,
          slug: this.slugify(item.name),
          members: this.filteredTeamMembers.filter((member) => {
            return member._embedded.teamMemberRelatedContent.engagements.some(engagement => engagement === item.name)
          }),
          subtabs: []
        })
      })

      this.engagements.filter(item => {
        return !!item.idEngagementParent
      }).forEach(item => {
        let team = teams.find(elem => elem.id === item.idEngagementParent)
        let members = this.filteredTeamMembers.filter((member) => {
            return member._embedded.teamMemberRelatedContent.engagements.some(engagement => engagement === item.name)
        })
        if(team && members.length) {
          team.subtabs.push({
            id: item.idEngagement,
            name: item.name,
            slug: this.slugify(item.name),
            members: members,
            subtabs: []
          })
        }
      })

      return teams.filter(item => {
        return item.members.length || item.subtabs.length
      })
    },
    filteredTeamMembers() {
      if(this.search) {
        return this.$store.getters.teamMembers.filter(member => {
          return member.name.toUpperCase().includes(this.search.toUpperCase()) || member.role.toUpperCase().includes(this.search.toUpperCase())
        })
      }
      return this.$store.getters.teamMembers
    },
    pageName() {
      return this.$store.getters.menu().find((item) => {
        return item.routeName === 'MeetYourTeam'
      })
    },
    section() {
      return this.$store.getters.sectionByCode(settings.MODULES.MEET_YOUR_TEAM)
    }
  },
  mounted() {
    window._paq.push(['setDocumentTitle', this.pageName.name]);
    window._paq.push(['trackPageView']);
    if(this.useTeamMembersTeams) {
      this.$store.dispatch('getEngagements')
    }
    this.$store.dispatch('getTeamMembers')
    this.updateNotificationDate();
  },
  methods: {
    updateNotificationDate() {
      settingUser.createSettingUser({
        idUser: this.$store.getters.user.idUser,
        idSettingCompany: this.section.idSettingCompany,
        valueDate: moment().format('YYYY-MM-DD HH:mm:ss'),
      }, () => {
        this.$store.dispatch('updateNotification', this.section.idSettingCompany)
        this.$store.dispatch('getUserInfo',  this.$store.getters.selectedCompanyId)
      })
    },
    slugify: slugify
  }
}
</script>
